import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeatureGrid() {
  const topArticles = articles.filter((a) => a.isTop).slice(0, 3);
  const mainArticle = topArticles[0];
  const sideArticles = topArticles.slice(1, 3);

  if (!mainArticle) return null;

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
          热点精选
          <span className="text-accent-500"> · 不容错过</span>
        </h2>
        <p className="mt-2 text-sm text-foreground-500">全网最火爆的娱乐八卦，都在这里</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
        <Link
          to={`/article/${mainArticle.id}`}
          className="relative lg:w-1/2 rounded-lg overflow-hidden group cursor-pointer h-[320px] md:h-[420px]"
        >
          <img
            src={mainArticle.imageUrl}
            alt={mainArticle.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
            <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
              今日Top1
            </span>
            <h3 className="mt-3 text-lg md:text-xl font-bold text-background-50 leading-snug line-clamp-2">
              {mainArticle.title}
            </h3>
            <p className="mt-2 text-sm text-background-50/70 line-clamp-2 hidden md:block">
              {mainArticle.excerpt}
            </p>
            <div className="mt-3 flex items-center gap-4 text-xs text-background-50/60">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {(mainArticle.viewCount / 10000).toFixed(1)}万
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line"></i>
                {mainArticle.commentCount}
              </span>
              <span>{mainArticle.publishDate}</span>
            </div>
          </div>
        </Link>

        <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
          {sideArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="relative flex-1 rounded-lg overflow-hidden group cursor-pointer min-h-[150px] md:min-h-[195px]"
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div
                className={`absolute inset-0 opacity-30 ${
                  index === 0 ? 'bg-accent-200/30' : 'bg-primary-200/30'
                }`}
              ></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span
                  className={`inline-block px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                    index === 0
                      ? 'bg-accent-100/90 text-accent-900'
                      : 'bg-primary-100/90 text-primary-900'
                  }`}
                >
                  {index === 0 ? '编辑精选' : '热门推荐'}
                </span>
                <h3 className="mt-2 text-base md:text-lg font-bold text-background-50 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <div className="mt-2 flex items-center gap-3 text-xs text-background-50/60">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.viewCount / 10000).toFixed(1)}万
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}